import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';

type CampaignBadgeProps = {
  campaignStyling: { background: string; text: string };
};

export const CampaignBadge = styled.div<CampaignBadgeProps>(
  props => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    font-size: ${layout.fontSizes.small.mobile.rem};
    font-weight: 600;
    color: ${props.campaignStyling.text};
    background: ${props.campaignStyling.background};
    border-radius: 12px;
    padding: ${layout.spacing.xxSmall} ${layout.spacing.xSmall};
    padding-left: ${layout.spacing.xxSmall};
    margin-bottom: ${layout.spacing.xxSmall};
    white-space: nowrap;
  `
);
